import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import useModal from '../../../shared/hooks/useModal';
import Api from '../../../util/api';
import DeleteModal from '../../../shared/components/custom/DeleteModal';
import { partial } from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';

const GoalSponsorPrizeList = ({ setLoading }) => {
  const [lotteryPrizes, setLotteryPrizes] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const p = partial('lotteries');
  const s = partial('shared');

  const fetchLotteryPrizes = async () => {
    setLoading(true);
    try {
      const resLotteryPrizes = await Api.lottery.prizes.getAllPrizes();
      setLotteryPrizes(resLotteryPrizes);
      setLoading(false);
    } catch (err) {
      toast.error(p('prizesRetrievingERROR'));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLotteryPrizes();
  }, []);
  const deleteLotteryPrize = async () => {
    setLoading(true);
    try {
      await Api.lottery.prizes.deletePrize(deleteID);
      toast.success(p('prizeDeleted'));
    } catch (err) {
      toast.error(p('errorRemovingPrize'));
    } finally {
      handleModal();
      fetchLotteryPrizes();
    }
  };

  const renderLotteryPrizes = () => {
    return lotteryPrizes.map((lotteryPrize, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`lottery-prize-${lotteryPrize.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <Link to={`/lottery/prizes/edit/${lotteryPrize.id}`}>
              {lotteryPrize.title}
            </Link>
          </div>
        </td>
        <td>{formatDate(lotteryPrize.createdAt)}</td>
        <td>{lotteryPrize.lotteryCount || 0}</td>
        <td>
          <UncontrolledDropdown className="dashboard__table-more">
            <DropdownToggle>
              <DotsHorizontalIcon />
            </DropdownToggle>
            <DropdownMenu className="dropdown__menu">
              <Link to={`/lottery/prizes/edit/${lotteryPrize.id}`}>
                <DropdownItem>{s('edit')}</DropdownItem>
              </Link>
              <DropdownItem
                onClick={() => handleModal(lotteryPrize.id)}
                className="danger"
              >
                {s('delete')}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));
  };
  return (
    <Container>
      <DeleteModal
        visible={visible}
        type={p('lotteryPrize')}
        handleModal={handleModal}
        modalAction={deleteLotteryPrize}
      />
      <Row>
        <Col>
          <div className="float-right marginTop-0">
            <Link to="/lottery/prizes/create">
              <Button size="sm" color="primary">
                {p('createLotteryPrize')}
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">{s('name')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">
                      {s('publicationDate')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">
                      {p('lotteryCount')}
                    </div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderLotteryPrizes()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default GoalSponsorPrizeList;
